import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import { formatNumberForLocale } from "../utils/locale";
import { PastTransactions } from "../bank/partials/pastTransactions";
import { Button } from "./partials/button";
import { GetGlobalColor } from "../utils/globalColors";
import Spinner from '../utils/spinner';

const Game = () => {
    const [admin, setAdmin] = useState();
    const [player, setPlayer] = useState();
    const [balance, setBalance] = useState(0);
    const navigate = useNavigate();
    const token = localStorage.getItem('userToken');
    const gameId = localStorage.getItem('gameId');
    const [transactions, setTransactions] = useState([]);
    const socket = useRef(null);
    const color = GetGlobalColor();
    const [loading, setLoading] = useState(true);


    const getTransactions = async () => {

        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/getPlayerTransactions`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token: token, gameId: gameId }),
            });

            const result = await response.json();
            if (result.transactions) {
                console.log("Response from API:", result);
                setTransactions(result.transactions.reverse())

            }

        } catch (error) {
            console.error("Error calling API:", error);
        }
    };

    const endGame = async () => {

        try {
            await fetch(`${process.env.REACT_APP_SERVER_URL}/endGame`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ gameId: gameId }),
            });


            navigate("/EndGame");



        } catch (error) {
            console.error("Error calling API:", error);
        }

    }

    const loadUserData = async () => {

        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/getPlayerData`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token: token, gameId: gameId }),
            });

            const result = await response.json();
            if (result.balance) {
                console.log("Response from API:", result);
                setBalance(result.balance.toLocaleString('de-DE'))
                setPlayer(result.player)
                setAdmin(result.isAdmin)
                socket.current = io(process.env.REACT_APP_SOCKET_URL, {
                    path: "/socket.io",
                    transports: ["websocket"],
                });

                const updateBalance = `update-balance-${localStorage.getItem('gameId')}-${result.player}`;
                socket.current.on(updateBalance, (newBalance) => {
                    setBalance(newBalance.newBalance)
                    getTransactions()
                });
                const end = `end-game-${localStorage.getItem('gameId')}`;
                socket.current.on(end, () => {
                    navigate("/EndGame")
                });

            }

        } catch (error) {
            console.error("Error calling API:", error);
        }
    };

    useEffect(() => {
        const init = async () => {
            try {
                await loadUserData();
                await getTransactions();
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };

        init();
    }, []);


    return (
        <div className={`app-bg-${color} bg-overwrite`}>
            {loading &&
                <Spinner />
            }
            <div className="flex flex-col items-center justify-center text-center h-[400px] mt-5 ">
                <p className="wtext">Osebni Račun • EUR</p>
                <p className="wtext text-5xl"> {formatNumberForLocale(balance)} €</p>

                <div className="flex space-x-4">
                    <Button onClick={() => navigate(`/Transaction`)} text={"Plačilo"} icon={"exchange"} />

                    {admin ? <>
                        <Button onClick={() => navigate(`/Bank`)} text={"Banka"} icon={"university"} />

                    </>
                        :
                        <Button onClick={() => { }} text={"Napolni"} icon={"add"} />
                    }

                    <Button onClick={() => navigate(`/Game/Extras`)} text={"Dodatno"} icon={"info"} />

                    {admin && <>
                        <Button onClick={() => {
                            if (window.confirm("Are you sure you want to end the game?")) {
                                endGame();
                            }
                        }} text={"Končaj"} text2={"igro"} icon={"hourglass-end"} />

                    </>
                    }


                </div>

            </div>
            <div className={`card-bg-${color} flex flex-col transaction min-h-[350px] max-h-[350px] overflow-y-auto`}>
                <PastTransactions transactions={transactions} player={player}></PastTransactions>
            </div>
        </div>
    );
};

export default Game;
